import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useRouter from 'common/hooks/use-router';

import Table from 'common/components/Table/Table';
import PageHeader from 'common/components/PageHeader/PageHeader';
import Button from 'common/components/Button/Button';

import usePriceArea from 'priceAreas/contexts/priceAreas';

const PriceAreaList = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const {
    fetchItems: fetchPriceAreas, items: priceAreas, isFetching, pageCount, remove, filters, setFilter,
    itemsCount,
  } = usePriceArea();

  const handleDelete = useCallback(async (row) => {
    await remove(row.original.id);
    await fetchPriceAreas();
  }, [remove, fetchPriceAreas]);

  const handleEdit = useCallback((row) => router.push(`/price-areas/edit/${row.original.id}`), [router]);

  const columns = useMemo(() => [
    {
      Header: t('priceAreas.id'),
      accessor: 'id',
    },
    {
      Header: t('common.name'),
      accessor: 'name',
      filterName: 'name_contains',
    },
    {
      Header: t('common.actions'),
      className: 'table-actions',
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => (
        <>
          <Button
            onClick={() => handleEdit(row)}
            icon="fa-pencil-alt"
            color="primary"
            transparent
          />
          <Button
            onClick={() => handleDelete(row)}
            icon="fa-trash-alt"
            color="danger"
            confirm
            transparent
            confirmMessage={t('priceAreas.confirmDelete')}
          />
        </>
      ),
    },
  ], [t, handleDelete, handleEdit]);

  return (
    <>
      <PageHeader
        title={t('menu.listPriceAreas')}
        link={{ url: '/price-areas/add', icon: 'plus', label: t('priceAreas.addPriceArea') }}
      />
      <section className="section list-page">
        <Table
          data={priceAreas}
          columns={columns}
          fetchData={fetchPriceAreas}
          isFetching={isFetching}
          pageCount={pageCount}
          filters={filters}
          setFilter={setFilter}
          itemsCount={itemsCount}
        />
      </section>
    </>
  );
};

export default PriceAreaList;
